<div class="my-bookings">
  <div class="row">
    <div class="col-md-6 col-9"><h1>{{ 'Notifications' | translate  }} <span class="badge badge-pill badge-primary ml-3">{{totalCount}}</span></h1> </div>
    <div class="col-md-6 col-3 text-right"> <button class="btnLink clearAllBtn" (click)="deleteAll()">{{ 'ClearAll' | translate  }}</button> </div>
  </div>

  <div class="search-results" infiniteScroll [infiniteScrollDistance]="5" [infiniteScrollThrottle]="30" [scrollWindow]="true"  (scrolled)="onScroll()">

  <table class="notification-table" >
		<tr  *ngFor="let notification of notificationsList; let i = index">
			<td class="notification-content">
       <div class="mb-2 notification-title" [innerHTML]="notification.title"></div>
       <div class="mb-1" [innerHTML]="notification.text"></div>
       <div class="notification-date">{{notification.date}}</div>
      </td>
			<td width="80px" class="text-center notification-delete" >
        <button class="btnLink" (click) = "deleteRow(notification)"><mat-icon>delete</mat-icon></button>
      </td>
		</tr>
  </table>  
  </div>

  <div class="no-available-info" *ngIf="notificationsList==null ||notificationsList.length == 0">
    <p class="mt-3"><i class="fas fa-info-circle mr-1"></i>  {{ 'NoNotificationYet' | translate }}</p> 
  </div>

</div>

